<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <ServiceForm :baseService="service" :baseserviceName="name" :loading="loading" @submit-requested="submitRequested"></ServiceForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import ServiceForm from '@/views/Services/ServiceForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                service: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { ServiceForm },
        computed:
        {
            ...mapState('services', ['getServiceByIdOutput']),
        },
        methods: {
            ...mapActions('services', ['getServiceById']),
            ...mapActions('services', ['putService']),
            submitRequested(service) {
                this.putService(service);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({ path: '/services/list' });
            }
            else {
                this.getServiceById(this.$route.query.id);
            }
        },
        watch:
        {
            getServiceByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({ path: '/services/list' });
                }
                else {
                    this.service = output.data;
                    this.loading = false;
                }
            }
        }
    }
</script>